import { useSelector } from 'react-redux';
import { paymentMethodTypes } from '@JohnLewisPartnership/checkout-psp-ui';
import cx from 'classnames';

// Design System
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import env from 'jl-design-system/utils/env/env';

// Types
import { ApplePayButtonProps } from './ApplePayButton.types';

// Config
import applePayButtonState from './ApplePayButton.state';

// Components
import StripePaymentProvider from '@components/payments/stripe/stripe-payment-provider';

// Styles
import styles from './apple-pay-button.scss';

const ApplePayButton = ({
  isExpress = false,
  isSubmitting = false,
  onClick = () => {},
  onReady = () => {},
}: ApplePayButtonProps) => {
  const { stripeCheckoutFlowEnabled } = useSelector(applePayButtonState);

  const shouldUseStubs = env.isClientLocal || env.isClientDev;

  if (stripeCheckoutFlowEnabled) {
    return (
      <StripePaymentProvider
        id="applePayButton"
        isStubbed={shouldUseStubs}
        onReady={(isReady: boolean) => onReady(isReady)}
        paymentMethodType={isExpress ? paymentMethodTypes.APPLE_PAY_EXPRESS : paymentMethodTypes.APPLE_PAY}
      />
    );
  }

  const appleStyle = {
    WebkitAppearance: '-apple-pay-button',
  };

  const buttonClassNames = cx('apple-pay-button-with-text', styles.applePayButton);

  return (
    <PrimaryButton
      className={styles.button}
      data-testid="apple-pay-button"
      disabled={isSubmitting}
      onClick={onClick}
      style={appleStyle}
    >
      <div className={buttonClassNames}>
        <span className="text">Buy with</span>
        <span className="logo" />
      </div>
    </PrimaryButton>
  );
};

export default ApplePayButton;
